<template>
    <div style="padding:10px;">
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1
                    style="margin-right:6px;font-size:16px; font-weight:500; margin-bottom:10px;background-color: #f56c6c; color: #fff;padding: 5px 10px;">
                    警告：技术人员清除测试数据，请勿乱操作！清除后无法恢复！</h1>
                <el-form ref="form">
                    <P style="color: #67c23a; font-size: 16px;">提示：保留商品、供应商、客户、权限申请数据资料</P>
                    <el-form-item label="是否保留基础资料">
                        <label slot="label" :style="$common.labelStyle('是否保留基础资料')"
                            v-html="$common.htmlLabel('是否保留基础资料')"></label>
                        <el-radio-group v-model="isBasic">
                            <el-radio-button :label="1">是</el-radio-button>
                            <el-radio-button :label="0">否</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="clearOut">清除数据</el-button>
                    </el-form-item>
                </el-form>
                <hr style='background-color:#409eff; height:1px; border:none;' />
                <div style="height:10px;"></div>
            </div>
        </div>

        <el-dialog title="清除数据验证" :visible.sync="pwdDialogVisible" width="400px" :close-on-click-modal="false"
            @close="resetPwdDialog">
            <el-form @submit.native.prevent>
                <el-form-item label="操作密码" label-width="80px">
                    <el-input v-model="password" type="password" placeholder="请输入密码" show-password clearable
                        @input="onPasswordInput" @keyup.enter.native="confirmPwd"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pwdDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmPwd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'initDataGl',
    components: {},
    data() {
        return {
            requesUrl: '',// 请求地址
            isBasic: 1,// 是否保留基础资料
            pwdDialogVisible: false,
            password: '',
            pwdCorrectTipShown: false,// 避免重复提示密码正确
        };
    },
    watch: {},
    computed: {},
    methods: {
        clearOut() {
            this.password = '';
            this.pwdCorrectTipShown = false;
            this.pwdDialogVisible = true;
        },
        resetPwdDialog() {
            this.password = '';
            this.pwdCorrectTipShown = false;
        },
        // 监听密码输入，正确时提示
        onPasswordInput(val) {
            if (val === 'dfsoft') {
                if (!this.pwdCorrectTipShown) {
                    this.pwdCorrectTipShown = true;
                    this.$message({
                        type: 'success',
                        message: '密码正确'
                    });
                }
            } else {
                this.pwdCorrectTipShown = false;
            }
        },
        confirmPwd() {
            if (!this.password) {
                return this.$message.warning('请输入密码');
            }
            if (this.password !== 'dfsoft') {
                return this.$message.error('密码错误');
            }
            if (!this.pwdCorrectTipShown) {
                this.$message({
                    type: 'success',
                    message: '密码正确'
                });
            }
            this.pwdDialogVisible = false;
            this.$confirm('是否继续清除数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.clearBasicData({
                    isBasic: this.isBasic,
                }).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: '清除成功'
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消清除'
                });
            });
        },
    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl; // 获取请求地址
    },
    mounted() { }
};
</script>
<style scoped></style>
